const SETTINGS_API = process.env.REACT_APP_SETTINGS_API_BASE_URI
const CACHE: Record<string, string> = {} // Cache to store connect URL

export class ForbiddenError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "ForbiddenError"
  }
}

export const fetchData = async (url: string, accessToken: string) => {
  //try {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  })

  if (response.status === 403) {
    throw new ForbiddenError("Access to the requested resource is forbidden.")
  }

  if (!response.ok) throw new Error(`Error ${response.status}: ${response.statusText}`)

  return await response.json()
  // } catch (error) {
  //   console.error(`Fetch failed: ${url}`, error)
  //   return null
  // }
}

export const getConnectUrl = async (accessToken: string, projectLocation: string): Promise<string | null> => {
  console.log("SettingsApi Base Address = ", SETTINGS_API)
  if (CACHE[projectLocation]) return CACHE[projectLocation] // Return cached value if available

  const data = await fetchData(`${SETTINGS_API}settings/${projectLocation}/all`, accessToken)
  const connectUrl = data?.connect?.uri
  if (connectUrl) {
    CACHE[projectLocation] = connectUrl // Store in cache to avoid redundant API calls
  } else {
    console.warn(`Failed to retrieve Connect URL for ${projectLocation}`)
  }

  return connectUrl
}

export const fetchFolderItems = async (folderId: string, accessToken: string, projectLocation: string) => {
  const connectUrl = await getConnectUrl(accessToken, projectLocation)
  if (!connectUrl) return []

  return (await fetchData(`${connectUrl}/folders/${folderId}/items`, accessToken)) ?? []
}

export const fetchProject = async (projectId: string, accessToken: string, projectLocation: string) => {
  const connectUrl = await getConnectUrl(accessToken, projectLocation)
  if (!connectUrl) return ""

  const projectData = await fetchData(`${connectUrl}/projects/${projectId}`, accessToken)
  return projectData
}

export const fetchProjectRootItems = async (projectId: string, accessToken: string, projectLocation: string) => {
  const connectUrl = await getConnectUrl(accessToken, projectLocation)
  if (!connectUrl) return []

  const projectData = await fetchData(`${connectUrl}/projects/${projectId}`, accessToken)
  if (!projectData?.rootId) return []

  return fetchFolderItems(projectData.rootId, accessToken, projectLocation)
}

export const fetchProjectRootId = async (projectId: string, accessToken: string, projectLocation: string) => {
  const connectUrl = await getConnectUrl(accessToken, projectLocation)
  if (!connectUrl) return ""

  const projectData = await fetchData(`${connectUrl}/projects/${projectId}`, accessToken)
  if (!projectData?.rootId) return ""
  return projectData?.rootId
}

export const fetchFileItem = async (fileId: string, accessToken: string, projectLocation: string) => {
  const connectUrl = await getConnectUrl(accessToken, projectLocation)
  if (!connectUrl) return []

  return (await fetchData(`${connectUrl}/files/${fileId}`, accessToken)) ?? []
}

export const fetchFolderItem = async (folderId: string, accessToken: string, projectLocation: string) => {
  const connectUrl = await getConnectUrl(accessToken, projectLocation)
  if (!connectUrl) return []

  return (await fetchData(`${connectUrl}/folders/${folderId}`, accessToken)) ?? []
}
